


interface TimerDisplayProps {
  minutes: number;
  seconds: number;
  isMobile?: boolean;
}

const TimerDisplay = ({ minutes, seconds, isMobile = false }) => {
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

  return (
    <div className="text-white text-center w-full">
      <div className="relative flex justify-center">
        <div className={`${isMobile ? 'text-6xl sm:text-7xl' : 'text-[8rem]'} font-inter font-light tracking-wider tabular-nums`}>
          {formattedMinutes}:{formattedSeconds}
        </div>
      </div>
    </div>
  );
};

export default TimerDisplay;
